import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import authService from "../services/authService";

import {
  validateEmail,
  validateMobile,
} from "../utils/Validations";

export default function AdminLogin() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const [loginError, setLoginError] = useState("");

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  /* =====================================================
     LOGIN FIELD VALIDATION
     EMAIL OR MOBILE NUMBER
  ===================================================== */

  const validateLoginField = (value) => {
    const loginValue = value?.trim() || "";

    if (!loginValue) {
      return "Email or phone number is required";
    }

    /*
      If only numbers are entered,
      validate as mobile number.
    */
    if (/^[0-9]+$/.test(loginValue)) {
      return validateMobile(loginValue);
    }

    /*
      Otherwise validate as email.
    */
    return validateEmail(loginValue);
  };

  /* =====================================================
     SUBMIT
  ===================================================== */

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* =================================================
       VALIDATE EMAIL / PHONE
    ================================================= */

    const loginValidation =
      validateLoginField(login);

    setLoginError(
      loginValidation === true
        ? ""
        : loginValidation
    );

    /*
      Stop if Email / Phone validation fails
    */
    if (loginValidation !== true) {
      return;
    }

    /* =================================================
       PASSWORD
       
       Only required validation.
       NO:
       - minimum 8 characters
       - capital letter
       - small letter
       - special character
    ================================================= */

    if (!password.trim()) {
      toast.error("Password is required");
      return;
    }

    setLoading(true);

    try {
      const res =
        await authService.adminLogin({
          email: login.trim(),
          password: password,
        });

      console.log(
        "ADMIN LOGIN RESPONSE:",
        res
      );

      toast.success(
        "Admin logged in successfully!"
      );

      navigate(
        "/admin/dashboard",
        {
          replace: true,
        }
      );

    } catch (err) {
      console.error(
        "ADMIN LOGIN ERROR:",
        err
      );

      toast.error(
        err?.response?.data?.message ||
        "Invalid credentials"
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-xxl">

      <div className="authentication-wrapper authentication-basic container-p-y">

        <div className="authentication-inner">

          <div className="card">

            <div className="card-body">

              {/* =================================================
                  LOGO
              ================================================= */}

              <div className="app-brand justify-content-center mb-3">

                <Link
                  to="/"
                  className="app-brand-link gap-2"
                >

                  <img
                    src="/Pharmacy_logo_1.svg"
                    alt="Logo"
                  />

                </Link>

              </div>


              {/* =================================================
                  TITLE
              ================================================= */}

              <h4 className="mb-4 text-center">
                Admin Panel 👋
              </h4>

              <p className="mb-4 text-center">
                Please sign-in to your admin account
              </p>


              {/* =================================================
                  FORM
              ================================================= */}

              <form
                onSubmit={handleSubmit}
                className="mb-3"
              >

                {/* =================================================
                    EMAIL / PHONE
                ================================================= */}

                <div className="mb-3">

                  <label className="form-label">
                    Email or Phone Number
                  </label>

                  <input
                    type="text"
                    value={login}
                    onChange={(e) => {

                      const value =
                        e.target.value;

                      setLogin(value);

                      /*
                        Clear previous validation
                        error while typing.
                      */
                      if (loginError) {
                        setLoginError("");
                      }

                    }}
                    className={`form-control ${
                      loginError
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Enter email or phone number"
                    autoComplete="username"
                  />


                  {/* =================================================
                      EMAIL / PHONE ERROR
                  ================================================= */}

                  {loginError && (

                    <div className="invalid-feedback">

                      {loginError}

                    </div>

                  )}

                </div>


                {/* =================================================
                    PASSWORD
                ================================================= */}

                <div className="mb-3">

                  <div className="d-flex justify-content-between">

                    <label className="form-label">
                      Password
                    </label>

                    <Link to="/forgot-password">

                      <small>
                        Forgot Password?
                      </small>

                    </Link>

                  </div>


                  <div className="input-group">

                    <input
                      type={
                        showPassword
                          ? "text"
                          : "password"
                      }
                      value={password}
                      onChange={(e) => {

                        setPassword(
                          e.target.value
                        );

                      }}
                      className="form-control"
                      placeholder="••••••••"
                      autoComplete="current-password"
                    />


                    {/* =================================================
                        SHOW / HIDE PASSWORD
                    ================================================= */}

                    <span
                      className="input-group-text cursor-pointer"
                      onClick={() =>
                        setShowPassword(
                          (prev) => !prev
                        )
                      }
                    >

                      <i
                        className={
                          showPassword
                            ? "bx bx-show"
                            : "bx bx-hide"
                        }
                      />

                    </span>

                  </div>

                </div>


                {/* =================================================
                    LOGIN BUTTON
                ================================================= */}

                <button
                  type="submit"
                  className="btn btn-primary d-grid w-100"
                  disabled={loading}
                >

                  {loading
                    ? "Signing in..."
                    : "Admin Sign in"}

                </button>

              </form>


              {/* =================================================
                  USER LOGIN
              ================================================= */}

              <p className="text-center mt-2">

                <Link to="/login">
                  Back to User Login
                </Link>

              </p>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}